import React, { useEffect } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import { useDialog } from "../../DialogContext";
import { useNavigate } from "react-router-dom";
import { generateUniqueMatterName } from "../../../styles/styles";
import {
  handleMatterNewTab,
  ListboxComponent,
  NoDataOptionField,
} from "../../../static/staticdata";
import { useDispatch, useSelector } from "react-redux";
import { getCases } from "../../../redux/Apps/Lawyerapp/CaseSlice/CaseSlice";
import { backend_api } from "../../../static/server";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import noOption from "../../../assets/no-option-found.webp";

const CreateDocWithTempForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { closeDialog } = useDialog();
  const { token } = useSelector((state) => state.user);
  const { allCase } = useSelector((state) => state.case);

  useEffect(() => {
    dispatch(getCases({ url: `${backend_api}case/register/`, token: token }));
  }, [dispatch, token]);
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    console.log(data);
  };
  return (
    <>
      <Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              p: "1rem",
            }}
          >
            <Controller
              name="doc_template"
              control={control}
              rules={{ required: "Category is required" }}
              render={({ field }) => (
                <FormControl size="small" fullWidth>
                  <Autocomplete
                    options={[]}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value
                    }
                    onChange={(_, newValue) =>
                      field.onChange(newValue?.value || "")
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Document template"
                        size="small"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
              )}
            />

            <Controller
              name="case"
              control={control}
              render={({ field }) => (
                <FormControl size="small" fullWidth error={errors?.case}>
                  <Autocomplete
                    {...field}
                    options={allCase || []}
                    getOptionLabel={(option) => {
                      if (!option) return "";
                      return generateUniqueMatterName(
                        option.id,
                        option.case_name
                      );
                    }}
                    value={
                      field.value
                        ? allCase?.find((item) => item.id === field.value)
                        : null
                    }
                    onChange={(_, newValue) =>
                      field.onChange(newValue?.id || null)
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Matter" size="small" />
                    )}
                    renderOption={(props, option) => (
                      <li {...props}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignItems: "center",
                          }}
                        >
                          <Typography>
                            {option.id
                              ? generateUniqueMatterName(
                                  option?.id,
                                  option?.case_name
                                )
                              : ""}
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              p: "0.2rem 0.5rem",
                              borderRadius: "1rem",
                              textAlign: "center",
                              fontSize: "0.7rem",
                              bgcolor:
                                option?.case_status === "open"
                                  ? "#4CAF50"
                                  : option?.case_status === "pending"
                                  ? "#FFC107"
                                  : "#F44336",
                              color: "#fff",
                            }}
                          >
                            {option?.case_status}
                          </Typography>
                        </Box>
                      </li>
                    )}
                    ListboxComponent={(props) => (
                      <ListboxComponent
                        {...props}
                        btnIcon={<ArrowOutwardRoundedIcon />}
                        btnText="Add Matter"
                        handleClikListBtn={handleMatterNewTab}
                      />
                    )}
                    noOptionsText={
                      <NoDataOptionField
                        imgSrc={noOption}
                        text="No matters found"
                        btnText="Matter"
                        handleClickNoData={() => navigate("/dashboard/matter")}
                      />
                    }
                  />
                </FormControl>
              )}
            />

            <Controller
              name="folder_name"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="File Name"
                  size="small"
                  fullWidth
                />
              )}
            />
            <Controller
              name="courtAppearances"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={<Checkbox {...field} checked={field.value} />}
                  label="Create a PDF document"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: "0.8rem",
                      fontWeight: 500,
                      color: "text.secondary",
                    },
                  }}
                />
              )}
            />
          </Box>
          <Box
            sx={{
              height: "fit-content",
              borderTop: "1px solid #ddd",
              position: "sticky",
              bottom: 0,
              backdropFilter: "blur(10px)",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              p: "0.5rem",
              zIndex: 1000,
              gap: "0.5rem",
            }}
          >
            <Button
              size="small"
              variant="outlined"
              onClick={() => closeDialog()}
            >
              Cancel
            </Button>
            <LoadingButton
              size="small"
              variant="contained"
              type="submit"
              color="primary"
            >
              Create Folder
            </LoadingButton>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default CreateDocWithTempForm;
